import { select, takeLatest } from '@redux-saga/core/effects'
import { put } from 'redux-saga/effects'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors'
import { getPatientDemographicsOptionsSelector } from '../selectors/patientDemographicsOptions.selector'
import { setPhoneDetails } from '../../patientDemographics/store/patientDemographics.actions'
import { OptionsConstants } from '../store/options.constants'
import { IPatientDemographicsOptionsState, IPhoneDetail } from '../store/options.types'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'

export function* setPhoneType() {
  const patientDemographicsOptions: IPatientDemographicsOptionsState = yield select(
    getPatientDemographicsOptionsSelector
  )
  const { phoneType, phoneDetail } = patientDemographicsOptions
  const patientDemographics: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const { phoneDetails } = patientDemographics
  const selectedPhone = phoneDetails.filter((phone: IPhoneDetail) => phone.key === phoneDetail?.key)
  if (selectedPhone && selectedPhone.length) {
    selectedPhone[0].type = phoneType
    yield put(setPhoneDetails(phoneDetails))
  }
}

export function* setPhoneTypeSaga() {
  yield takeLatest([OptionsConstants.SET_PHONE_TYPE], setPhoneType)
}
